<template>
  <el-container v-cloak class="box">
     <div class="headerCom">
        <publicBreadCrumb :breadList="breadList" />
        <publicExpandSearch padBottom="0px" :searchList='searchList' v-on:getSearchObj='getSearchObj'>
        </publicExpandSearch>
     </div>
    <el-main class="bottom-tabel">
      <el-table :data="tableData" :header-cell-style="{
			  background:'#FAFAFA',
			  fontWeight: 'bold',
			  color: '#333333',
			  fontSize:'14px'
			}">
        <el-table-column align="center" prop="patientName" label="患者姓名">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.patientName"
              :disabled="scope.row.patientName&&scope.row.patientName.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.patientName | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="name" label="逻辑名称">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.name" :disabled="scope.row.name&&scope.row.name.length>8?false:true"
              placement="top">
              <span class="fieldWidth">{{ scope.row.name | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="triggerTimes" label="激活次数">
        </el-table-column>
        <el-table-column align="center" prop="period" label="服务周期">
          <template slot-scope="scope">
            {{scope.row.period}}{{scope.row.periodType}}
          </template>
        </el-table-column>
        <el-table-column v-if="userPlatForm=='platForm'" align="center" prop="updateUserName" label="线下机构">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.belongTo"
              :disabled="scope.row.belongTo&&scope.row.belongTo.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.belongTo | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="updateUserName" label="编辑人">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.updateUserName"
              :disabled="scope.row.updateUserName&&scope.row.updateUserName.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.updateUserName | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="updateTime" label="更新时间">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.updateTime"
              :disabled="scope.row.updateTime&&scope.row.updateTime.length>8?false:true" placement="top">
              <span class="fieldWidth">{{ scope.row.updateTime | filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">未激活</span>
            <span v-if="scope.row.status==1">已激活</span>
            <span v-if="scope.row.status==2">已结束</span>
          </template>
        </el-table-column>

        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button @click="checkDetail(scope.row)" type="text" size="small">
              查看
            </el-button>
            <el-button @click="publishClick(scope.row)" type="text" size="small" v-if="!scope.row.isSame">
              {{"发布"}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>

  </el-container>
</template>

<script>
import {
  decisionTreePage,
  decisionTreeInsertReturnId,
  decisionTypeList,
  decisionTreePublish,
  decisionTreeSubmitApproval,
  cancelApproval,
  patientSchemePublish,
  patientSchemePage,
  apiDepartmentScreen
} from "./api";
import local from "@/utils/local.js";
import { api_get_disease_type } from "@/api/ManagementPlan";
export default {
  data() {
    return {
      breadList: [{ name: "决策设置" }, { name: "患者逻辑" }],
      searchList: [
        {
          label: "患者姓名",
          paramName: "patientName",
          inputType: "input" 
        },
        {
          label: "逻辑名称",
          paramName: "name",
          inputType: "input" 
        },
        {
          label: "服务周期",
          paramName: "period",
          inputType: "input",
          width:'160px',
          unit:'天' 
        },
        {
          label: "编辑人",
          paramName: "updateUserName",
          inputType: "input" 
        },  
        {
          label: "状态",
          paramName: "status",
          inputType: "select",
          remote: false,
          optionData: [
            {
              label: "未激活", 
              value: 0
            },
            {
              label: "已激活", 
              value: 1
            },
            {
              label: "已结束", 
              value: 2
            }
          ]
        }  
      ],
      rightEventList: [{ eventName: "新增", eventValue: 1 }],
      searchParams: { 
					current: 1,
					size: 10,
			},
      // listQuery1: {
      //   name: null,
      //   patientName: "",
      //   period: undefined,
      //   updateUserName: "",
      //   status: ""
      // },
      // listQuery: {
      //   platformId: "",
      //   patientName: "",
      //   period: "",
      //   // periodType:"天",
      //   name: "",
      //   status: null,

      //   current: 1,
      //   size: 10
      // },
      userid: local.get("userid"),
      form: {
        description: "",
        name: "",
        diseaseId: "",
        subDiseaseIds: [],
        typeId: "",
        diseaseName: ""
      },
      dialogFormVisible: false,
      total: 0,
      tableData: [],
      // decisionType: [],
      diseaseListData: [],
      formRule: {
        name: [
          {
            required: true,
            message: "请输入逻辑名称",
            trigger: "blur"
          }
        ],
        // description: [
        // 	{ required: true, message: '请输入描述', trigger: 'blur' },
        // ],
        typeId: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change"
          }
        ],
        diseaseId: [
          {
            required: true,
            message: "请选择主适配病种",
            trigger: "change"
          }
        ]
      },
      // periodTypeList:["天","月","周","季","年"],
      // hospitalList: [
      //   {
      //     label: "患者姓名",
      //     value: 1
      //   },
      //   {
      //     label: "逻辑名称",
      //     value: 2
      //   },
      //   {
      //     label: "服务周期",
      //     value: 3
      //   },
      //   {
      //     label: "编辑人",
      //     value: 4
      //   },
      //   {
      //     label: "状态",
      //     value: 5
      //   }
      // ],
	   userPlatForm:"platForm",
     platformList:[],
     platformIndex:"",
    //  platformListName:""
    };
  },
  created() {
    this.init();
    // decisionTypeList({}).then(res => {
    //   this.decisionType = res.data;
    // });
    this.userid = local.get("userid");
    // getDisease() {
    api_get_disease_type().then(res => {
      if (res.code == 0) {
        this.diseaseListData = res.data;
      }
    });
    this.getOrg()
    // },
  },
  mounted() { 
	   this.userPlatForm = this.$store.state.userPlatForm;
     if(this.userPlatForm=="platForm"){
       this.searchList.push({
          label: "线下机构",
          paramName: "hospitalId",
          inputType: "hospital" 
        },)
     }
  },
  methods: {
     getSearchObj(obj) { 
      if(obj.hospitalName){
        delete obj.hospitalName
      }
      this.searchParams = this.$options.data().searchParams;
			this.searchParams = { ...obj, ...this.searchParams };   
      this.init();
    },
    //从子组件接收机构id,name
    // getChooseHospitalId(val,name){
    //   this.listQuery1.hospitalId=val;
    //   this.platformListName=name
    // },
    goFenlei() {
      this.$router.push("/decisionPage/classificationSettings");
    },
    platformChange(val){
      this.platformIndex=this.platformList.findIndex(item=>{
        return item.id==val
      })
    },
    getOrg() {
      //归属平台下拉列表筛选项
      apiDepartmentScreen({}).then(res => {
        if (res.code == 0) {
          this.platformList = res.data;
        }
      });
    },
    // resetHandel() {
    //   for (var i = 1; i < 7; i++) {
    //     this.tagClose(i);
    //   }
    //   this.listQuery.size = 10;
    //   this.listQuery.current = 1;
    //   this.listQuery = this.$options.data().listQuery;
    //   this.init();
    // },
    // tagClose(v) {
    //   if (v == 1) {
    //     this.listQuery.patientName = "";
    //     this.listQuery1.patientName = "";
    //   }
    //   if (v == 2) {
    //     this.listQuery.name = "";
    //     this.listQuery1.name = "";
    //   }
    //   if (v == 3) {
    //     this.listQuery.period = "";
    //     this.listQuery1.period = undefined;
    //   }
    //   if (v == 4) {
    //     this.listQuery.updateUserName = "";
    //     this.listQuery1.updateUserName = "";
    //   }

    //   if (v == 5) {
    //     this.listQuery1.status = null;
    //     this.listQuery.status = null;
    //   }
    //   if (v == 6) {
    //     this.listQuery1.hospitalId = null;
    //     this.listQuery.hospitalId = null;
    //   }
    //   this.listQuery.platformId = "";
    //   this.queryHandel();
    // },
    // queryHandel() {
    //   if (
    //     this.listQuery.platformId == 1 &&
    //     this.listQuery1.patientName.trim() != ""
    //   ) {
    //     this.listQuery.patientName = this.listQuery1.patientName;
    //   }
    //   if (this.listQuery.platformId == 2 && this.listQuery1.name.trim() != "") {
    //     this.listQuery.name = this.listQuery1.name;
    //   }
    //   if (this.listQuery.platformId == 3 && this.listQuery1.period != "") {
    //     this.listQuery.period = this.listQuery1.period;
    //   }
    //   if (
    //     this.listQuery.platformId == 4 &&
    //     this.listQuery1.updateUserName.trim() != ""
    //   ) {
    //     this.listQuery.updateUserName = this.listQuery1.updateUserName;
    //   }

    //   if (this.listQuery.platformId == 5) {
    //     this.listQuery.status = this.listQuery1.status;
    //   }
    //   if (this.listQuery.platformId == 6) {
    //     this.listQuery.hospitalId = this.listQuery1.hospitalId;
    //   }
    //   this.listQuery.size = 10;
    //   this.listQuery.current = 1;

    //   this.init();
    // },
    checkDetail(data) {
      this.setDecisionTreeObj(data.id);
      this.$router.push({
        path: "/decisionPage/TemplateApproval",
        query: {
          id: data.id
        }
      });
    },
    //存决策树id及区分模板编辑||患者编辑页面
    setDecisionTreeObj(id) {
      let obj = {
        pageName: "patientPage", //模板编辑：templatePage 患者编辑：patientPage
        decisionTreeId: id
      };
      localStorage.setItem("decisionTreeObj", JSON.stringify(obj));
    },
    NowApproval(data) {
      this.setDecisionTreeObj(data.id);
      this.$router.push({
        path: "/decisionPage/TemplateApproval",
        query: {
          id: data.id
        }
      });
    },
    publishClick(data) {
      patientSchemePublish(data.id).then(res => {
        this.$message.success("操作成功");
        this.init();
      });
    },
    Approval(data) {
      if (data.status == 2) {
        cancelApproval(data.id).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      } else {
        decisionTreeSubmitApproval({
          id: data.id
        }).then(res => {
          this.$message.success("操作成功");
          this.init();
        });
      }
    },
    // saveDescription() {
    //   this.$refs["ruleForm"].validate(valid => {
    //     if (valid) {
    //       let obj;
    //       if (this.form.subDiseaseIds.length) {
    //         let subArr = [];
    //         this.diseaseListData.forEach(item => {
    //           this.form.subDiseaseIds.forEach(v => {
    //             if (item.id === v) {
    //               subArr.push(item.suborderName);
    //             }
    //           });
    //         });
    //         obj = {
    //           description: this.form.description,
    //           name: this.form.name,
    //           diseaseId: this.form.diseaseId,
    //           diseaseName: this.form.diseaseName,
    //           subDiseaseIds: this.form.subDiseaseIds.join(","),
    //           subDiseaseNames: subArr.join(","),
    //           typeId: this.form.typeId
    //         };
    //       } else {
    //         obj = {
    //           description: this.form.description,
    //           name: this.form.name,
    //           diseaseId: this.form.diseaseId,
    //           diseaseName: this.form.diseaseName,
    //           typeId: this.form.typeId
    //         };
    //       }
    //       decisionTreeInsertReturnId(obj).then(res => {
    //         this.$message.success("操作成功");
    //         this.dialogFormVisible = false;
    //         this.init();
    //       });
    //     } else {
    //       return false;
    //     }
    //   });
    // },
    // returnText(id, arr, nowKey, Key) {},
    // diseaseTypeChange1(v) {
    //   this.listQuery1.diseaseName = "";
    //   for (var i = 0; i < this.diseaseListData.length; i++) {
    //     if (v == this.diseaseListData[i].id) {
    //       this.listQuery1.diseaseName = this.diseaseListData[i].suborderName;
    //     }
    //   }
    // },
    diseaseTypeChange(v) {
      this.form.diseaseName = "";
      for (var i = 0; i < this.diseaseListData.length; i++) {
        if (v == this.diseaseListData[i].id) {
          this.form.diseaseName = this.diseaseListData[i].suborderName;
        }
      }
    },
    init() {
      // this.listQuery.platformId = "";
      patientSchemePage(this.searchParams).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    resetForm() {
      this.form.subDiseaseIds = [];
      this.$refs["ruleForm"].resetFields();
    },
    addInfo() {
      this.dialogFormVisible = true;
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.init();
    }
  }
};
</script>

<style scoped lang="less">
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}
.fieldWidth {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/deep/.el-textarea textarea {
  min-height: 120px !important;
}

// .header {
//   background-color: #fff;
//   margin-bottom: 16px;
//   padding: 0 24px;

//   .text {
//     margin-bottom: 16px;
//     color: #333333;
//     font-size: 14px;
//     line-height: 22px;
//     padding-top: 20px;

//     span:nth-child(2) {
//       color: #333;
//     }

//     span:nth-child(1) {
//       color: #999;
//     }
//   }

//   .float-right {
//     float: right;
//   }
// }

.bottom-tabel {
  background-color: #fff;
  padding: 16px 17px 0;
  margin: 0 15px;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}

/deep/.el-select {
  width: 100%;
}
</style>

